module.exports = __webpack_public_path__ + "img/a2.5e10df6e.jpg";